<template>
	<v-card width="900px" rounded="xl" class="no-scroll">
		<v-card-title class="create-card bg-secondary">
			<div class="d-flex justify-space-between">
				<strong>{{ $t('agent_information') }}</strong>
				<v-icon class="icon" @click="closeDialog">mdi-close</v-icon>
			</div>
		</v-card-title>
		<v-header>
			<div style="height: 7rem; background-color: #ffc2c6"></div>
		</v-header>
		<v-card-text>
			<div>
				<v-avatar color="grey" size="150" class="ml-5" style="position: relative; margin-top: -6rem;"
					:image="customer.pictureUrl"></v-avatar>
				<v-btn size="45" icon="" style="
						position: absolute;
						left: 160px;
						z-index: 999;
						background-color: rgba(17, 17, 17, 0.7);
					" @click="pickFile">
					<v-icon size="24" class="text-white">mdi-image-edit</v-icon>
					<input ref="fileRef" class="d-none" type="file" @change="uploadImage($event)"></input>
				</v-btn>
				<v-row class="my-2">
					<v-col cols="6">
						<label for="title" style="font-weight: 600">
							{{ $t('full_name') }}<span>*</span>
						</label>

						<v-text-field variant="outlined" v-model="customer.name" density="compact"
							size="50"></v-text-field>
						<label for="title" style="font-weight: 600">
							{{ $t('email') }} <span>*</span>
						</label>
						<v-text-field variant="outlined" v-model="customer.email" density="compact"
							size="50"></v-text-field>
					</v-col>
					<v-col cols="6">
						<div>
							<label for="title" style="font-weight: 600">
								{{ $t('contact_number') }}<span>*</span>
							</label>
							<vue-tel-input :enabledCountryCode="true" mode="international" v-model="customer.phone"
								style="padding: 0.3rem"></vue-tel-input>
						</div>

					</v-col>
				</v-row>
			</div>
		</v-card-text>
		<v-footer class="create-card bg-secondary">
			<div class="d-flex flex-row-reverse w-100">
				<v-btn variant="text" @click="updateCustomerProfile">{{ $t('save_change') }}</v-btn>
			</div>
		</v-footer>
	</v-card>
</template>

<script>
export default {
	data: () => ({
		// loader: {
		// 	showSubmittingLoader: false,
		// },
		file: null,
		customer: {}
	}),
	created() {
		this.customer = this.customerDetail
	},

	emits: ['closeDialog', 'emitUpdateCustomerProfile'],
	props: {
		customerDetail: {
			type: Object,
			required: false,
		}
	},
	methods: {
		closeDialog() {
			this.$emit('closeDialog')
		},
		pickFile() {
			this.$refs.fileRef.click()
		},
		uploadImage(event) {
			const file = event.target.files[0];

			if (file) {
				if (this.customer.pictureUrl) {
					URL.revokeObjectURL(this.customer.pictureUrl);
				}
				this.file = file
				this.customer.pictureUrl = URL.createObjectURL(file);
			}
		},
		updateCustomerProfile() {
			this.$emit('emitUpdateCustomerProfile', {
				customerDetail: this.customerDetail,
				id: this.customerDetail.id,
				pictureUrl: this.file,
			})
			this.closeDialog()
		},
	}
}
</script>

<style scoped>
.no-scroll {
	overflow: hidden;
	height: 100%;
}

.responsive-phone-field {
	padding: 0.3rem;
	width: 100%;
	/* Set initial width to 100% */
}
</style>
